export default function PlusCuestion() {
    return (
        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.27876 11V6.314H0.592758V4.664H5.27876V0H6.92876V4.664H11.5928V6.314H6.92876V11H5.27876Z" fill="#07BB7A" />
        </svg>

    )
}